import Pusher from 'pusher-js';
import Echo from "laravel-echo";
export default function createSocketConnection() {
    if (!window.Echo) {
        const token = localStorage.getItem("connect_token");
        const isSecure = window.location.protocol === 'https:';
        window.Echo = new Echo({
            broadcaster: 'pusher',
            key: 'key56556563562563624376',
            wsHost: process.env.REACT_APP_SOCKET_URL,
            wssHost: process.env.REACT_APP_SOCKET_URL,
            wsPort: 6001,
            wssPort: 6002,       // nginx WSS proxy port (mkcert cert)
            forceTLS: isSecure,  // wss:// when page is HTTPS, ws:// otherwise
            encrypted: isSecure,
            disableStats: true,
            authEndpoint: isSecure
                ? process.env.REACT_APP_SOCKET_AUTH_URL_HTTPS || process.env.REACT_APP_SOCKET_AUTH_URL
                : process.env.REACT_APP_SOCKET_AUTH_URL,
            auth: {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        });
    }
}